<template>
  <section class="state">
    <img class="state__img" src="@/assets/ban.svg" />
    <h1 class="state__heading">
      {{ heading }}
    </h1>
    <span class="state__status g-status g-status_error">{{ reason }}</span>
    <a v-if="BRAND_CONFIG.supportDeskUri"
       :href="`${BRAND_CONFIG.supportDeskUri}`" class="g-button">{{
      $t("REQUEST_SUPPORT_OR_SUBSCRIPTION_CANCELLATION")
    }}</a>
  </section>
</template>

<script>
export default {
  props: ['reason', 'heading'],
  computed: {
    title() {
      return this.$t('ERROR');
    },
  },
};
</script>

<style lang="scss" scoped>
.state {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;

  &__img {
    max-width: 100%;
  }

  &__heading {
    font-size: 16px;
    font-weight: 500;
    margin: 15px 0 10px;
  }

  &__status {
    font-size: 14px;
    margin-bottom: 15px;
  }
}
</style>
